<template>
  <div class="col-12" v-if="tableData.length != 0">
    <div class="card">
      <div class="card-body p-3 mt-3">
        <div class="card-title text-center">
          <h3>{{ $t("malware.queue-analysis-malware") }}</h3>
        </div>
        <div class="row mt-4 px-2">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t("table.show_label") }}&nbsp;&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  class="mx-1"
                ></b-form-select
                >&nbsp;&nbsp;{{ $t("table.entri_label") }}
              </label>
            </div>
          </div>
          <!-- Search -->
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                {{ $t("table.search_label") }}:
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('navbar.search.text')"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0 px-2">
          <b-table
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(no)="row">
              <span>{{ row.index + 1 }}</span>
            </template>
            <template #cell(created_at)="row">
              <span>{{ formatDate(row.item.created_at) }}</span>
            </template>
            <template #cell(running_vm)="row">
              <div v-if="row.item.sandbox == 'ahn_lab'">
                <span v-if="row.item.running_vm == 'vm1'">Windows XP</span>
                <span v-if="row.item.running_vm == 'vm2'">Windows 7</span>
                <span v-if="row.item.running_vm == 'vm3'">Windows 10</span>
                <span v-if="row.item.running_vm == 'vm4'">Windows 11</span>
              </div>
              <div v-if="row.item.sandbox == 'cp_lab'">
                <span class="mr-2">Windows XP</span>
                <span>Windows 7</span>
              </div>
            </template>
            <template #cell(status)="row">
              <span
                class="badge badge-info p-1 px-1 badge-md rounded"
                variant="secondary"
                v-if="row.item.status == 0"
              >
                On Prosess</span
              >
              <span
                class="badge badge-success p-1 px-1 rounded"
                v-else-if="row.item.status == 1"
              >
                Done</span
              >
            </template>
          </b-table>
        </div>
        <div class="row px-2" v-if="rows > 10">
          <div class="col-2">
            <label class="d-inline-flex align-items-center">
              Page
              <b-form-input
                v-model="currentPage"
                placeholder="Page"
                class="form-control w-10 form-control ml-2"
              ></b-form-input>
            </label>
          </div>
          <div class="col-10 text-right" v-if="rows > 10">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul
                class="pagination pagination-rounded mb-0"
                :class="
                  theme == 'dark' ? 'custom-paginate-dark' : 'custom-paginate'
                "
              >
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QueueService from "@/helpers/queue.service";
import MalwareService from "@/helpers/malware.service";
import PreferencesServices from "@/helpers/preferences.service";
import ElasticServices from "@/helpers/elastic.service";
import moment from "moment";
import detailMalwareVue from "./detail-malware.vue";
import Helpers from "@/helpers/auxiliary.function";

/**
 * Projects-grid component
 */
export default {
  props: {
    runQueue: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      theme: localStorage.getItem("theme") ?? "light",
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "md5",
          sortable: true,
          label: "MD5",
        },
        {
          key: "filename",
          sortable: true,
          label: this.$t("malware.file-name"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("malware.upload-date"),
        },
        {
          key: "running_vm",
          sortable: true,
          label: "Running VM",
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("malware.status"),
        },
      ],
      elastic_api_host: "",
      ip_elastic_cp: "",
      ip_elastic_ahn: "",
      checkInterval: "",
    };
  },
  watch: {
    tableData: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal.length != 0) {
          this.checkScheduler();
        }
      },
    },
    runQueue: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.list();
        }
      },
    },
    runCheckExist: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.checkIfExist();
        }
      },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getPreferencesCp() {
      PreferencesServices.getByKey("elastic", "checkpoint")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesCp();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_cp = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesCp();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    getPreferencesAhn() {
      PreferencesServices.getByKey("elastic", "ahn_lab")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesAhn();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_ahn = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesAhn();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    list() {
      QueueService.list()
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.list();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.tableData = res.data.data;
            if (this.tableData.length == 0) {
              clearInterval(this.checkInterval);
            }
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            // this.loading_upload = false;
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.list();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },

    checkScheduler() {
      if (this.tableData.length != 0) {
        this.checkInterval = setInterval(() => {
          // this.tableData.forEach((el, idx) => {
          //   setTimeout(() => {
          //     this.n8nCheck(el.id_malware);
          //   }, 3000);
          //   this.list();
          // });
          if (this.tableData.length != 0) {
            this.tableData.forEach((el, idx) => {
              setTimeout(() => {
                this.checkQueue(idx, el);
              }, 3000);
            });
          } else {
            this.list();
          }
        }, 10000);
      }
    },

    n8nCheck(id) {
      const bodyData = {
        id: id,
      };
      QueueService.n8ncheck(bodyData)
        .then((res) => {
          console.log("n8n success ", res);
        })
        .catch((err) => {
          console.log("n8n failed ", err);
        });
    },

    checkIfExist(val) {
      const sb = "";
      switch (val.sandbox) {
        case "1":
          sb = "cp_lab";
          break;
        case "1":
          sb = "ahn_lab";
          break;
        default:
          break;
      }
      let data = {
        id_malware: val.malware.id,
        sandbox: sb,
      };
      this.checkQueue(0, data);
    },

    checkQueue(idx, data) {
      if (data.sandbox == "ahn_lab") {
        const bodyData = {
          id_malware: data.id_malware,
        };
        MalwareService.ahnRequestStatus(bodyData)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.checkQueue(idx, data);
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let detailMalware = res.data.data;
              if (detailMalware.status == "done") {
                if (detailMalware.download.length != 0) {
                  this.downloadAnalysisFile(
                    detailMalware.download,
                    data.id_malware
                  );
                }

                if (this.tableData.length != 0) {
                  this.tableData[idx].status = "1";
                }

                this.updateQueue(data.id_malware, detailMalware);
                setTimeout(() => {
                  if (this.tableData.length != 0) {
                    this.tableData.splice(idx, 1);
                  }
                }, 1500);
              }
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.checkQueue(idx, data);
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                if (this.tableData.length != 0) {
                  this.tableData[idx].status = "1";
                }
                this.updateQueue(data.id_malware, detailMalware);
              }
              // this.loading_upload = false;
            }
          });
      }
      if (data.sandbox == "cp_lab") {
        const bodyData = {
          md5: data.md5,
          file_type: data.filetype,
          file_name: data.filename,
        };
        console.log("body ", bodyData);
        MalwareService.cpRequestStatus(bodyData)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.checkQueue(idx, data);
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let detailMalware = res.data.data;
              if (
                detailMalware.response.te.images[0].status != "pending" &&
                detailMalware.response.te.images[1].status != "pending"
              ) {
                this.tableData[idx].status = "1";

                this.updateQueue(data.id_malware, detailMalware);
                setTimeout(() => {
                  this.tableData.splice(idx, 1);
                }, 1500);
              }
            }
          })
          .catch((err) => {
            console.log("err ->> ", err);
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.checkQueue(idx, data);
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                if (this.tableData.length != 0) {
                  this.tableData[idx].status = "1";
                }
                // this.updateQueue(data.id_malware);
              }
              // this.loading_upload = false;
            }
          });
      }
    },

    updateQueue(id_malware, detailMalware) {
      const bodyData = {
        id_malware: id_malware,
        status: "1",
      };
      QueueService.update(bodyData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateQueue(id_malware, detailMalware);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            const dataQueue = res.data.data;
            console.log("data ", dataQueue);
            console.log("data 2", detailMalware);
            if (dataQueue.sandbox == "ahn_lab") {
              this.storeToElasticAhn(detailMalware, dataQueue);
            }
            if (dataQueue.sandbox == "cp_lab") {
              this.storeToElasticCp(detailMalware, dataQueue);
              if (detailMalware.response.te.summary_report != "") {
                this.decodeReport(
                  detailMalware.response.md5,
                  detailMalware.response.te.summary_report
                );
              }
            }
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateQueue(id_malware, detailMalware);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              //**  handle response failed here
              console.log("err update Queue : " + id_malware + "=> ", err);
            }
          }
        });
    },

    downloadAnalysisFile(downloadlist, id_malware) {
      downloadlist.forEach((element) => {
        if (element != "file") {
          const dwData = {
            id_malware: id_malware,
          };
          MalwareService.ahnAnalysisFile(element, dwData)
            .then((res) => {
              if (res.status == 201) {
                let new_token = res.data.refresh_access_token;
                userService.splitToken(new_token);
                this.downloadAnalysisFile(downloadlist, id_malware);
                this.$store.dispatch("notification/refreshtoken", "refresh");
              } else {
                console.log(
                  "succ download " + element + " malware : " + id_malware,
                  res
                );
              }
            })
            .catch((err) => {
              if (err.response == undefined) {
                console.log("err ->> ", err);
              } else if (
                this.$store.state.notification.type === "refresh-token" &&
                err.response.status == 401
              ) {
                this.downloadAnalysisFile(downloadlist, id_malware);
              } else {
                if (err.response.status == 401) {
                  userService.logout();
                } else {
                  //**  handle response failed here
                  console.log(
                    "fail download " + element + " malware : " + id_malware,
                    err
                  );
                }
              }
            });
        }
      });
    },

    storeToElasticAhn(malware, queue) {
      if (this.ip_elastic_ahn.username && this.ip_elastic_ahn.password) {
        let usps =
          this.ip_elastic_ahn.username + ":" + this.ip_elastic_ahn.password;
        let base = Helpers.encode(usps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }
      const ipHost =
        this.ip_elastic_ahn.api_host +
        "_doc/" +
        malware.md5sum +
        "_" +
        queue.running_vm;
      let malwareData = {
        id: malware.id,
        detect_time: malware.detect_time,
        status: malware.status,
        md5sum: malware.md5sum,
        file_name: malware.file_name,
        file_type: malware.file_type,
        detect_name: malware.detect_name,
        file_size: malware.file_size,
        severity: malware.severity,
        my_id: malware.my_id,
        parent_id: malware.parent_id,
        unknown: malware.unknown,
        download: malware.download,
        related: malware.related,
        running_vm: queue.running_vm,
        analysis_time: queue.analysis_time,
      };

      ElasticServices.storeAhnLab(ipHost, malwareData, basedata_ahn)
        .then((res) => {
          console.log("store elastic success", res);
        })
        .catch((err) => {
          console.log("store elastic failed", err);
        });
    },

    storeToElasticCp(malware, queue) {
      if (this.ip_elastic_cp.username && this.ip_elastic_cp.password) {
        let usps =
          this.ip_elastic_cp.username + ":" + this.ip_elastic_cp.password;
        let base = Helpers.encode(usps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      const ipHost = this.ip_elastic_cp.api_host + "_doc/" + queue.md5;
      const malwareData = {
        ...malware.response,
        ...{
          detect_time: queue.created_at,
          analysis_time: queue.analysis_time,
        },
      };
      // console.log("store elastic CP =>>  ", malwareData);
      ElasticServices.storeCpLab(ipHost, malwareData, basedata_cp)
        .then((res) => {
          console.log("store elastic success", res);
        })
        .catch((err) => {
          console.log("store elastic failed", err);
        });
    },

    decodeReport(md5, id_report) {
      const bodyData = {
        md5: md5,
        id_report: id_report,
      };

      MalwareService.decodeReport(bodyData)
        .then((res) => {
          // this.detailInfo.push(res.data.data);
          console.log("decode ", res);
        })
        .catch((err) => {
          console.log("decode err ", err);
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(val) {
      return moment(val).format("YYYY-MM-DD, hh:mm");
    },
  },
  beforeMount() {
    this.getPreferencesCp();
    this.getPreferencesAhn();
  },
  mounted() {
    this.list();
    this.checkScheduler();
  },
};
</script>
<style>
.upload-setting {
  border: solid 3px #052a38;
  border-radius: 5px;
}
.pagination-rounded .page-link {
  outline: none !important;
  margin: 0 2px;
  border: 1px solid #ced4da;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
